import packageJSON from '../../package.json'

const APP_PROJECT = process.env.REACT_APP_PROJ

export const AppProject = (): JSX.Element => {
  return (
    <p className="font-light tracking-wider uppercase text-xs">
      <small>{APP_PROJECT}</small>
    </p>
  )
}
